module.exports = __webpack_public_path__ + "img/pin-bau.75acd8ee.svg";